import { Summary } from '../projects/qr-izi/contexts/types'
import { LocalSession } from '../types/localStorage'

export const getLocalQrSession = (): LocalSession[] => {
  const sessionQRString = window.localStorage.getItem('sessionQR')

  return sessionQRString ? JSON.parse(sessionQRString) : []
}

export const clearCurrentSessionByPathSlug = (pathSlug: string) => {
  const sessionQR = getLocalQrSession()

  const filteredSession = sessionQR?.filter((session) => session.path !== pathSlug)

  if (filteredSession.length) {
    window.localStorage.setItem('sessionQR', JSON.stringify(filteredSession))
  } else {
    window.localStorage.removeItem('sessionQR')
  }

  window.localStorage.removeItem('zipCode')
}

export const setLocalStep = (step: number, slug: string) => {
  const sessionQR = getLocalQrSession()

  window.localStorage.setItem(
    'sessionQR',
    JSON.stringify(sessionQR?.map((session) => (session.path === slug ? { ...session, countStep: step } : session))),
  )
}

export const getLocalZipCodeAndCity = () => {
  try {
    const zipCode = window.localStorage.getItem('zipCode')
    const city = window.localStorage.getItem('city')

    return zipCode && city
      ? { zipCode: JSON.parse(zipCode) as string, city: JSON.parse(city) as string }
      : { zipCode: undefined, city: undefined }
  } catch (_) {
    return { zipCode: undefined, city: undefined }
  }
}

export const setLocalSummary = (summary: Summary, slug: string) => {
  const sessionQR = getLocalQrSession()

  window.localStorage.setItem(
    'sessionQR',
    JSON.stringify(sessionQR?.map((session) => (session.path === slug ? { ...session, summary } : session))),
  )
}
